import React from 'react';

const baseProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const LocationIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1 1 16 0z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

export const StyleIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export const InstrumentIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M9 18V8l11-4v10" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="17" cy="14" r="3" />
  </svg>
);

export const StarIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <polygon points="12 2 15 8.5 22 9.3 17 14.1 18.2 21 12 17.8 5.8 21 7 14.1 2 9.3 9 8.5 12 2" />
  </svg>
);

export const AmpIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M4 21h16M5 21V7l7-4 7 4v14M9 9h.01M15 9h.01M9 14h.01M15 14h.01" />
  </svg>
);

export const KeysIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M12 3v18M3 7v10M21 7v10M7 5v14M17 5v14" />
  </svg>
);

export const PencilIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

export const ShareIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5-5 5 5M12 5v12" />
  </svg>
);

export const EyeIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const ArrowRightIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} strokeWidth={2.4} {...props}>
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);

export const BellIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M18 16v-5a6 6 0 1 0-12 0v5l-2 3h16l-2-3z" />
    <path d="M10 21a2 2 0 0 0 4 0" />
  </svg>
);

export const UsersIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const WaveIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseProps} {...props}>
    <path d="M2 12c2-4 6-4 8 0s6 4 8 0M2 18c2-4 6-4 8 0s6 4 8 0" />
  </svg>
);

export const PlayIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M8 5v14l11-7z" />
  </svg>
);
